import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import ShowsCarousel from './components/ShowsCarousel';
import SizeGuideModal from './components/SizeGuideModal';
import Testimonials from './components/Testimonials';
import BrandLogos from './components/BrandLogos';
import Newsletter from './components/Newsletter';
import LiveChat from './components/LiveChat';
import Footer from './components/Footer';
import AdminBookings from './components/AdminBookings';
import { mockData } from './data/mock';

function HomePage() {
  const [sizeGuideOpen, setSizeGuideOpen] = useState(false);

  const handleBookingClick = () => {
    const newsletterSection = document.getElementById('newsletter');
    if (newsletterSection) {
      newsletterSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Header onSizeGuideClick={() => setSizeGuideOpen(true)} />
      
      <Hero data={mockData.hero} onBookingClick={handleBookingClick} />
      
      <About data={mockData.about} />
      
      <ShowsCarousel shows={mockData.shows} />
      
      <Testimonials testimonials={mockData.testimonials} />
      
      <BrandLogos brands={mockData.brands} />
      
      <Newsletter />
      
      <Footer contact={mockData.contact} />
      
      <SizeGuideModal 
        isOpen={sizeGuideOpen} 
        onClose={() => setSizeGuideOpen(false)}
        sizeGuide={mockData.sizeGuide}
      />
      
      <LiveChat />
      
      <Toaster />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;